import * as React from 'react';
import { Select, MenuItem, Checkbox, ListItemText, InputLabel, FormControl } from '@material-ui/core';
export default (options) => (props) => {
    const selectOptions = options ? options.selectOptions || [] : [];
    const value = props.value || [];
    return (React.createElement(FormControl, { fullWidth: true },
        React.createElement(InputLabel, null, props.propertyOptions.displayName),
        React.createElement(Select, { value: value, fullWidth: true, multiple: true, onChange: (e) => {
                props.setValue(e.target.value.filter((value) => selectOptions.some((option) => value === option)));
            }, renderValue: (e) => {
                if (e instanceof Array) {
                    return `${e.join(', ')}`;
                }
                return '';
            } }, selectOptions.map((selectOption) => {
            const checked = value.some((value) => value === selectOption);
            return (React.createElement(MenuItem, { key: selectOption, value: selectOption },
                React.createElement(Checkbox, { checked: checked }),
                React.createElement(ListItemText, { primary: selectOption })));
        }))));
};
